// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellAndMessage16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-and-message': IconBellAndMessage;
    }
}

/**
 * The icon component for the 'bellAndMessage' icon
 */
export class IconBellAndMessage extends IconSvg {
    public constructor() {
        super(bellAndMessage16X16);
    }
}

registerIconSvg('icon-bell-and-message', IconBellAndMessage);
export const iconBellAndMessageTag = 'nimble-icon-bell-and-message';
